/* eslint-disable no-invalid-this */

function and(...args) {
  return args.find(arg => arg.toString() === "false") === undefined;
}

export default and;
